<template>
    <div class="single-chart">
    <svg viewBox="0 0 36 36" class="circular-chart orange">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path class="circle"
        :stroke-dasharray="cnt"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="21.35" class="percentage">{{cnt}}%</text>
    </svg>
  </div>
</template>
<script>
export default {
    props: {
        percent:{default:null},
    },
    data() {
        return {
            cnt:0,
            interval:null
        }
    },
    methods: {
        countPercent () {
            if(this.percent === null)
                return
            this.interval = setInterval (()=> {
                this.cnt++;
                if (this.cnt >= this.percent || this.cnt >= 99) {
                    clearInterval(this.interval);
                }
            },50)
        }
    },
    watch: {
        percent: function (value){
            this.interval = setInterval (()=> {
                this.cnt++;
                if (this.cnt >= value || this.cnt >= 99) {
                    clearInterval(this.interval);
                }
            },50)
        }
    },
    mounted() {
        this.countPercent();
    }
}
</script>
<style lang="less" scoped>
.flex-wrapper {
  display: flex;
  flex-flow: row nowrap;
}

.single-chart {
  width: 90%;
  justify-content: space-around ;
}

.circular-chart {
  display: block;
  margin: 3px auto;
  max-width: 80%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: @colors[red];
  stroke-width: 1.8;
}

.circle {
  fill: none;
  stroke-width: 1.8;
  //stroke-linecap: round;
  //animation: progress 8s ease-out forwards;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart.orange .circle {
  stroke: @colors[green];
}

.circular-chart.green .circle {
  stroke: #4CC790;
}

.circular-chart.blue .circle {
  stroke: #3c9ee5;
}

.percentage {
  fill: @colors[green];
  font-family: Arimo;
  font-size: 11px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  text-anchor: middle;
}
</style>
